// @flow

import { Avatar, Col, Row, Switch } from "antd";
import { Button } from "../../components/common";
import { Checkbox } from "views/components/Checkbox";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import {
	Content,
	ProfileHeader,
	ProfilePicture,
	Wrapper,
} from "./ProfileScreen.styles";
import { DropDown } from "views/components/common/Form";
import { FlatButton } from "views/components/FlatButton";
import { Form, Input } from "views/components/common/Form";
import {
	PhoneSection,
	WhatsappSection,
} from "views/mobile/components/Popup/Popup.styles";
import { ReactSVG } from "react-svg";
import { Select } from "views/mobile/components/Toggle";
import { Spacer } from "views/components/common/Spacer";
import { UserOutlined } from "@ant-design/icons";
import { getColor } from "../../../resources/theme";
import { not, pathOr } from "ramda";
import { pushNotificacionSubscriptionProfile } from "lib/subscribeToPushNotifications";
import { set } from "immutable";
import { updateUser } from "network/login";
import { useCurrentBreakpointName } from "react-socks";
import Header from "../../components/Header";
import Icon, { Icons } from "react-hp-icons";
import Provider from "views/components/ProfileScreen";
import React, { useEffect, useGlobal, useState } from "reactn";
import format, {
	formatPhoneWithoutCountryCode,
	validate,
	validateShortPhone,
} from "lib/rut";
import iconWhatsapp from "views/resources/icons/whatsapp.svg";
import PhoneInput from "../../../components/PhoneInput/Index";

const leftColumnGrid = {
	xs: 6,
	sm: 6,
	md: 4,
	lg: 2,
	xl: 2,
	xxl: 2,
};

const rightColumnGrid = {
	xs: 18,
	sm: 18,
	md: 20,
	lg: 22,
	xl: 22,
	xxl: 22,
};

const validateRut = (v = "") => validate(v) && v.length > 5;

const ProfileScreen = ({
	userId,
	push,
	whatsapp,
	handleChange,
	inputs,
	setInputs,
	onLogout,
	loading,
	error,
	resolved,
	updateUserInfo,
	history,
	handlePhoneChange,
	isPhoneValid,
	setIsPhoneValid,
	isSubmitDisabled,
}) => {
	const currentBp = useCurrentBreakpointName();

	const inputsLength = inputs && inputs.rut && inputs.rut.length > 3;

	const handleDisabled =
		(inputs.type === "rut" && inputsLength && !validateRut(inputs.rut)) ||
		!isPhoneValid;

	const handlerToggle = push;
	const onChangeToggle = (checked) => {
		setInputs((i) => ({ ...i, push: checked }));
		pushNotificacionSubscriptionProfile(checked, userId);
	};

	return (
		<Wrapper>
			{currentBp === "mobile" && (
				<>
					<Header
						title="Perfil"
						transparent
						goBack={history.goBack}
					/>
					<ProfileHeader>
						<ProfileHeader.Title>Tu Perfil</ProfileHeader.Title>
						<ProfileHeader.Description>
							Aquí podrás cambiar tus datos personales, ver
							estadísticas y enviar comentarios
						</ProfileHeader.Description>
					</ProfileHeader>
				</>
			)}
			<Content>
				<Row justify="center">
					<Col>
						<Avatar size={80} icon={<UserOutlined />} />
					</Col>
				</Row>
				<h3>Datos Personales</h3>
				<Input
					validator={(v) => true}
					label="Nombre"
					name="name"
					value={inputs.name}
					onChange={handleChange}
				/>
				<Spacer rows={2} />
				<Select
					name="type"
					value={inputs.type}
					opts={[
						{ htmlValue: "dni", label: "DNI" },
						{ htmlValue: "rut", label: "RUT" },
					]}
					onChange={handleChange}
				/>
				{inputs.type === "rut" ? (
					<Input
						validator={validateRut}
						key="rut"
						label="RUT"
						errorMessage="RUT inválido"
						name="rut"
						value={inputs.rut}
						onChange={handleChange}
						postInput={format}
					/>
				) : (
					<Input
						validator={() => Boolean(inputs.dni)}
						key="dni"
						label="DNI"
						errorMessage="DNI inválido"
						name="dni"
						value={inputs.dni}
						onChange={handleChange}
					/>
				)}
				<Spacer rows={1} />
				<PhoneSection>
					<h3>Número de Teléfono</h3>
					<PhoneInput
						onChange={handlePhoneChange}
						value={
							inputs.phone !== "null"
								? `${inputs.countryCode.slice(1)}${
										inputs.phone
								  }`
								: ""
						}
						validator={setIsPhoneValid}
					/>
				</PhoneSection>
				<Spacer rows={2} />
				<h3> Notificaciones </h3>
				<WhatsappSection>
					<div className="whatsappBox">
						<Row align="bottom">
							<Col span={21}>
								<Switch
									defaultChecked={handlerToggle}
									onChange={onChangeToggle}
								/>
							</Col>
						</Row>
					</div>
				</WhatsappSection>
				<Spacer rows={2} />
				<Row
					style={{ marginBottom: 24, marginLeft: 0 }}
					justify="start"
					align="middle"
					gutter={[24, 24]}
				>
					<Col>
						<FlatButton
							disabled={isSubmitDisabled}
							loading={loading}
							text="Actualizar"
							onClick={updateUserInfo}
						/>
					</Col>
					<Col>
						<FlatButton
							text="Cerrar Sesión"
							color="secondary"
							onClick={onLogout}
							outlined
						/>
					</Col>
				</Row>
			</Content>
		</Wrapper>
	);
};

export default Provider(ProfileScreen);
